import type {Node as ProseMirrorNode} from "@tiptap/pm/model";

export const PRINTOUT_HEADER_NODE_NAME = "printoutHeader";
export const PRINTOUT_FOOTER_NODE_NAME = "printoutFooter";

export type PrintoutRegionKind = "header" | "footer";

// Page regions accept only bounded content with predictable height.
export const PRINTOUT_REGION_CONTENT = "(paragraph | heading | table | printoutDivider | printoutImage)+";

// DOM contract shared with pagination and print styles.
export const PRINTOUT_REGION_ATTRIBUTE = "data-printout-region";
export const PRINTOUT_REGION_PLACED_ATTRIBUTE = "data-printout-region-placed";

export const PRINTOUT_REGION_BAND_ATTRIBUTE = "data-printout-region-band";

export const PRINTOUT_REGION_CLASS = "printout-region";
export const PRINTOUT_REGION_CONTENT_CLASS = "printout-region-content";
export const PRINTOUT_REGION_BAND_CLASS = "crqlar-printout-region-band";
export const PRINTOUT_REGION_CLONE_CLASS = "crqlar-printout-region-clone";

export const PRINTOUT_HEADER_HEIGHT_VARIABLE = "--crqlar-printout-header-height";
export const PRINTOUT_FOOTER_HEIGHT_VARIABLE = "--crqlar-printout-footer-height";
export const PRINTOUT_REGION_DECORATION_BREAK_VARIABLE = "--crqlar-printout-region-decoration-break";

export const getPrintoutRegionNodeName = (kind: PrintoutRegionKind) => (
    kind === "header" ? PRINTOUT_HEADER_NODE_NAME : PRINTOUT_FOOTER_NODE_NAME
);

export const getPrintoutRegionKind = (nodeName: string): PrintoutRegionKind | null => {
    if (nodeName === PRINTOUT_HEADER_NODE_NAME) return "header";
    if (nodeName === PRINTOUT_FOOTER_NODE_NAME) return "footer";

    return null;
};

export const isPrintoutRegionEmpty = (node: ProseMirrorNode) => (
    node.childCount <= 1 && node.firstChild?.type.name === "paragraph" && node.firstChild.content.size === 0
);

export const findPrintoutRegion = (
    doc: ProseMirrorNode,
    kind: PrintoutRegionKind,
): {node: ProseMirrorNode; pos: number} | null => {
    const name = getPrintoutRegionNodeName(kind);

    if (kind === "header") {
        const first = doc.firstChild;

        return first?.type.name === name ? {node: first, pos: 0} : null;
    }

    const last = doc.lastChild;

    return last?.type.name === name
        ? {node: last, pos: doc.content.size - last.nodeSize}
        : null;
};
